// Inbox-rooted prefix that all SLW internal routes hang off.
export const BASE_PATH = '/rental-manager/inbox';

export const MAX_OLD_CONVERSATION_DAYS = 660;

export const SAVED_REPLY_TITLE_MAX_LENGTH = 80;
export const SAVED_REPLY_MESSAGE_MAX_LENGTH = 2000;

export default {
  BASE_PATH,
  MAX_OLD_CONVERSATION_DAYS,
  SAVED_REPLY_TITLE_MAX_LENGTH,
  SAVED_REPLY_MESSAGE_MAX_LENGTH,
};
